// LOGIN
export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL    = "LOGIN_USER_FAIL";

// LOGOUT
export const LOGOUT_USER    = "LOGOUT_USER";
